/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserGroupVehicleGroupAssignment
 */
export interface UserGroupVehicleGroupAssignment {
    /**
     * 
     * @type {string}
     * @memberof UserGroupVehicleGroupAssignment
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof UserGroupVehicleGroupAssignment
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof UserGroupVehicleGroupAssignment
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof UserGroupVehicleGroupAssignment
     */
    userGroupId: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupVehicleGroupAssignment
     */
    vehicleGroupId: string;
}

/**
 * Check if a given object implements the UserGroupVehicleGroupAssignment interface.
 */
export function instanceOfUserGroupVehicleGroupAssignment(value: object): value is UserGroupVehicleGroupAssignment {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('userGroupId' in value) || value['userGroupId'] === undefined) return false;
    if (!('vehicleGroupId' in value) || value['vehicleGroupId'] === undefined) return false;
    return true;
}

export function UserGroupVehicleGroupAssignmentFromJSON(json: any): UserGroupVehicleGroupAssignment {
    return UserGroupVehicleGroupAssignmentFromJSONTyped(json, false);
}

export function UserGroupVehicleGroupAssignmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserGroupVehicleGroupAssignment {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'userGroupId': json['userGroupId'],
        'vehicleGroupId': json['vehicleGroupId'],
    };
}

export function UserGroupVehicleGroupAssignmentToJSON(json: any): UserGroupVehicleGroupAssignment {
    return UserGroupVehicleGroupAssignmentToJSONTyped(json, false);
}

export function UserGroupVehicleGroupAssignmentToJSONTyped(value?: UserGroupVehicleGroupAssignment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'userGroupId': value['userGroupId'],
        'vehicleGroupId': value['vehicleGroupId'],
    };
}

